import { E2NTableCell } from '../../../../components/Table';
import { memo } from 'react';
import { Mitarbeiter } from '../../entities';
import { MitarbeiterAvatar } from '../Avatar/MitarbeiterAvatar';
import { Link } from 'react-router-dom';
import { managerV1BaseUrl } from '@/utils';

export const MitarbeiterCell = memo(function MitarbeiterCell({
  mitarbeiter,
}: {
  mitarbeiter: Mitarbeiter;
}) {
  return (
    <E2NTableCell className="rounded-l-lg w-40" isBorderVisible>
      <Link
        to={`${managerV1BaseUrl}/secure/v2/in/search.jsf?idMitarbeiter=${mitarbeiter.id}`}>
        <div className="flex gap-4 items-center font-semibold group">
          <MitarbeiterAvatar
            vorname={mitarbeiter.vorname}
            nachname={mitarbeiter.nachname}
            bildUrl={mitarbeiter.bildUrl ?? ''}
            extern={mitarbeiter.extern ?? false}
          />
          <span className="truncate md:max-w-40 max-w-28 group-hover:underline">
            {`${mitarbeiter.vorname} ${mitarbeiter.nachname}`}
          </span>
        </div>
      </Link>
    </E2NTableCell>
  );
});
